import classNames from 'classnames';
import React, { Component } from 'react';
import ReactModal from 'react-modal';
import IconButton from "../../../../common/buttons/icon-button/IconButton";
import styles from './DeleteProjectGroupModal.module.scss';
import { IDeleteProjectGroupModalProps } from "./IDeleteProjectGroupModalProps";
import { IDeleteProjectGroupModalState } from "./IDeleteProjectGroupModalState";

class DeleteProjectGroupModal extends Component<IDeleteProjectGroupModalProps, IDeleteProjectGroupModalState> {

  private static removeDialogIndex = 100;

  constructor(props: IDeleteProjectGroupModalProps) {
    super(props);

    this.state = {
      dialogId: 'delete_project_group_dialog_' + (DeleteProjectGroupModal.removeDialogIndex++)
    };

    this.onConfirmClicked = this.onConfirmClicked.bind(this);
  }

  render() {
    return (
      <ReactModal
        appElement={document.getElementById('root') as HTMLElement}
        isOpen={this.props.showDialog}
        id={this.state.dialogId}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        className={classNames([styles.dialog, "shadow p-4"])}
      >
        <h2>Delete project group</h2>

        <p>
          Are you sure you want to delete <b className={"text-break"}>{this.props.groupNameToDelete}</b>?
          All of it's child items will be reassigned to current parent of this group
          <b className={"text-break"}> {this.props.groupParentName}</b>.
        </p>

        <div className="d-flex justify-content-end">
          <IconButton onClick={this.onConfirmClicked} variant="outline-primary" title="Delete"
                      styles={{marginRight: '1em'}}/>
          <IconButton onClick={this.props.onCancel} variant="outline-primary" title="Cancel"/>
        </div>
      </ReactModal>
    );
  }

  onConfirmClicked() {
    if (this.props.onConfirm !== undefined && this.props.onConfirm !== null) {
      this.props.onConfirm(this.props.groupIdToDelete ?? 0);
    }
  }
}

export default DeleteProjectGroupModal;